import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Tooltip } from 'core/components/label-tooltip';

import SortableTable from 'core/components/sortable-table';
import { Label } from 'core';
import { currencyFormatter, capitalizeWords, awsDateToDateFormatter } from 'core/helpers/formatters';
import styles from '../payment.styles';

const PastPayments = ({ classes, transactions, getBillingPaymentMethod }) => {
  const shortenInternalDescription = (internalDescription) => {
    if (internalDescription?.length > 13) {
      return (
        <>
          {`${internalDescription.slice(0, 15)}...`}
          <Tooltip label="See more" text={internalDescription} />
        </>
      );
    }
    return internalDescription;
  };

  return (
    <div className={classes.sectionContainer}>
      <Grid container alignItems="center" justify="flex-start" className={classes.rowTitle}>
        <Label type="coverageValue">Past Payments</Label>
      </Grid>
      <Grid container alignItems="flex-start" justify="flex-start" className={classes.thirdRow}>
        {transactions && transactions.length > 0 && (
          <SortableTable
            classes={{
              'dark-tableRowRoot': classes.tableRow,
              'dark-tableCellRoot': classes.tableCell,
              'dark-tableHeadRoot': classes.tableHead
            }}
            mode="dark"
            dataCy="policies"
            selfContained={false}
            headers={[
              ['paymentDate', 'Date'],
              ['paymentAmount', 'Amount'],
              ['paymentRefunded', 'Amount Refunded'],
              ['paymentMethod', 'Payment Method'],
              ['paymentStatus', 'Payment Status'],
              ['internalDescription', 'Description']
            ]}
            data={transactions}
            formatters={{
              paymentDate: awsDateToDateFormatter,
              paymentAmount: currencyFormatter,
              paymentRefunded: currencyFormatter,
              paymentStatus: capitalizeWords,
              internalDescription: shortenInternalDescription,
              paymentMethod: (p, transaction) =>
                getBillingPaymentMethod(
                  transaction.paymentMethod,
                  transaction.paymentMethodBrand,
                  transaction.paymentMethodLast4,
                  classes.tableBodyPaymentMethodLast4
                )
            }}
          />
        )}
      </Grid>
    </div>
  );
};

PastPayments.propTypes = {
  classes: PropTypes.object.isRequired,
  transactions: PropTypes.array.isRequired,
  getBillingPaymentMethod: PropTypes.func.isRequired
};

export default withStyles(styles)(PastPayments);
